import { Button } from "@/components/ui/button"

interface Props {
  /** Text on the forward button. */
  label: string
  /** Omitted by steps there is no way back to. */
  onBack?: () => void
  /**
   * Steps that own a form leave this out and let the button submit, so the
   * Enter key and the click take the same path.
   */
  onNext?: () => void
  isSubmitting?: boolean
}

/** Both buttons share the wizard's rounding and press feedback. */
const PRESSABLE =
  "flex-1 rounded-lg active:scale-[0.97] motion-reduce:active:scale-100"

/** The button row at the foot of a step. */
export function OnboardingFooter({
  label,
  onBack,
  onNext,
  isSubmitting,
}: Props) {
  return (
    <div className="flex gap-2.5 px-9 pt-5">
      {onBack && (
        <Button
          type="button"
          variant="outline"
          onClick={onBack}
          data-testid="onboarding-back"
          className={PRESSABLE}
          disabled={isSubmitting}
        >
          Back
        </Button>
      )}
      <Button
        type={onNext ? "button" : "submit"}
        onClick={onNext}
        disabled={isSubmitting}
        data-testid="onboarding-next"
        className={PRESSABLE}
      >
        {label}
      </Button>
    </div>
  )
}
